import { useState, useEffect } from 'react';
import { parseToken } from '../../utils';
import { useClientTokenManager } from '../../context/ClientTokenManager';
export function useCurrentUserId() {
    const { accessToken } = useClientTokenManager();
    const [currentUserId, setCurrentUserId] = useState(null);
    useEffect(() => {
        if (!accessToken) {
            return;
        }
        const decoded = parseToken(accessToken);
        if (!decoded) {
            return;
        }
        setCurrentUserId(decoded?.cko_user_id ?? null);
    }, [accessToken]);
    return { currentUserId };
}
